import React, { useState, useEffect, useCallback, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { notification, Empty, Switch, Row, Col } from 'antd';
import { formValueSelector } from 'redux-form';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {
  deleteMerchantWallet,
  resetPageCounter,
  setWalletAsMain,
  resetTwoFaState,
  getWalletPrivateKey,
  getWalletMnemonicPhrase,
  getPassphrase,
} from '../../../redux/actions/merchantWallets';
import ReactPaginate from 'react-paginate';
import { getMerchantData } from '../../../redux/actions/merchantData';
import WalletsFilters from '../../../components/WalletsPage/WalletsFilters';
import ReplenishModal from '../../../components/ReplenishModal/ReplenishModal';
import PrivateKeyModal from '../../../components/WalletsPage/PrivateKeyModal';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import '../../../components/WalletsPage/WalletsList.scss';
import { getUserMerchants } from '../../../redux/actions/adminPanel/adminUsers';
import {
  checkAutosignStatus,
  setPasswordSignature,
  downloadAutosign,
  checkPasswordStatus,
  downloadNewAutosignError,
} from '../../../redux/actions/withdraw';
import WalletItem from '../../../components/WalletsPage/WalletItem';
import AdminWalletItemV2 from './AdminWalletItemV2';
import WalletDeleteModal from '../../../components/WalletsPage/MerchantWalletsActions/WalletDeleteModal';
import WalletSettingsModal from '../../../components/WalletsPage/MerchantWalletsActions/WalletSettingsModal';
import SignPasswordModal from '../../../components/SignPasswordModal/SignPasswordModal';
import PasswordModal from '../../../components/WalletsPage/PasswordModal';
import { adminApi } from '../../../service/admin-api';
import { identity } from '../../../utils/getIdentity';

const AdminMerchantWalletsList = ({
  formName,
  merchantId,
  networkFilter,
  typeWallet,
  currencies,
  userId,
  deleteMerchantWallet,
  setWalletAsMain,
  resetTwoFaState,
  getWalletPrivateKey,
  getWalletMnemonicPhrase,
  getPassphrase,
  autosignStatus,
  setPasswordSignature,
  downloadAutosign,
  passwordStatus,
  checkAutosignStatus,
  checkPasswordStatus,
  autosignStep,
  downloadAutosignStep,
  downloadError,
  userMerchants,
  resetPageCounter,
  walletsFilters,
  getMerchantData,
  merchantData,
}) => {
  const [walletId, setWalletId] = useState('');
  const [walletAddress, setWalletAddress] = useState('');
  const [walletCurrency, setWalletCurrency] = useState('');
  const [isReplenishModalOpen, setIsReplenishModalOpen] = useState(false);
  const [isKeyModalOpen, setIsKeyModalOpen] = useState(false);
  const [adminPage, setAdminPage] = useState(1);
  const [adminPages, setAdminPages] = useState(1);
  const [hideZeroCheckbox, setHideZeroCheckbox] = useState(
    JSON.parse(localStorage.getItem('cpayHideZeroBalancesMerchant')) || false
  );
  const [walletsAdmin, setWalletsAdmin] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [showWalletBy, setShowWalletBy] = useState(null);
  const [name, setName] = useState('');
  const [securityRefreshedWalletId, setSecurityRefreshedWalletId] = useState(null);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [isOpenSignPassword, setIsOpenSignPassword] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const [isOpenDownload, setIsOpenDownload] = useState(false);
  const [modalTitle, setModalTitle] = useState(false);
  const [password, setPassword] = useState('');
  const selectedWalletRef = useRef(null);
  selectedWalletRef.current = selectedWallet;
  const dispatch = useDispatch();

  const { pathname } = useLocation();
  const isFromMerchantsWallets = pathname.includes('/merchants/wallets') || pathname === '/wallets';
  const [walletVersionTick, setWalletVersionTick] = useState(0);
  const [adminWalletVersion, setAdminWalletVersion] = useState(undefined);
  const walletVersionStorageKey = merchantId
    ? `adminMerchantWalletVersion:${merchantId}`
    : 'adminMerchantWalletVersion';
  const effectiveWalletVersion =
    adminWalletVersion || (merchantData?._id === merchantId ? merchantData?.settingWallet?.version : undefined);
  const canSwitchWalletVersion =
    merchantData?.settingWallet?.version === 'v2' &&
    merchantData?.settingWallet?.defaultSetup === 'v1';

  const isV2 = effectiveWalletVersion === 'v2';

  useEffect(() => {
    const bump = () => setWalletVersionTick(n => n + 1);
    const onStorage = e => {
      if (e.key === 'walletVersion') bump();
    };
    window.addEventListener('walletVersionChange', bump);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('walletVersionChange', bump);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  const defaultFilterValues = {
    order: 'DESC',
    search: '',
    limit: 10,
    currencyIds: currencies.filter(currency => currency.currencyType === 'currency').map(currency => currency._id),
    typeNetwork: networkFilter,
  };

  const getAdminMerchantWallet = async body => {
    setLoading(true);

    try {
      const response = await adminApi.getAdminMerchantWallet(userId, merchantId, body);
      if (response?.data) {
        setAdminPage(response?.data?.page);
        setAdminPages(response?.data?.pages);
        setWalletsAdmin(response?.data?.entities);
      } else {
        setWalletsAdmin([]);
      }
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (merchantId) {
      const storedVersion = localStorage.getItem(walletVersionStorageKey);
      setAdminWalletVersion(storedVersion || undefined);
    }
  }, [merchantId]);

  useEffect(() => {
    if (merchantId && adminWalletVersion) {
      localStorage.setItem(walletVersionStorageKey, adminWalletVersion);
    }
  }, [merchantId, adminWalletVersion]);

  useEffect(() => {
    dispatch(getUserMerchants(userId));
  }, [userId]);

  useEffect(() => {
    if (userMerchants?.length > 0 && merchantId) {
      const name = userMerchants?.filter(item => item?._id === merchantId);
      setName(name[0]?.name);
    } else {
      setName('');
    }
  }, [userMerchants, merchantId]);

  useEffect(() => {
    if (merchantId) {
      getMerchantData(merchantId, userId);
    } else if (defaultFilterValues?.currencyIds?.length > 1) {
      const { currencyIds } = defaultFilterValues;
      getAdminMerchantWallet({
        ...defaultFilterValues,
        order: walletsFilters?.order || 'DESC',
        currencyIds: currencyIds.join(',') || undefined,
        typeWallet: typeWallet,
        showTokens: true,
        positiveBalance: hideZeroCheckbox,
        ...(effectiveWalletVersion ? { walletVersion: effectiveWalletVersion } : {}),
      });
    } else if (defaultFilterValues?.currencyIds?.length === 0) {
      setWalletsAdmin([]);
    }
  }, [merchantId, networkFilter, hideZeroCheckbox, walletVersionTick, effectiveWalletVersion, adminWalletVersion]);

  useEffect(() => {
    if (defaultFilterValues?.currencyIds?.length > 1 && merchantData?._id === merchantId) {
      const currentCurrencyIds =
        walletsFilters?.currencyIds?.length > 0
          ? walletsFilters.currencyIds
          : defaultFilterValues.currencyIds;
      getAdminMerchantWallet({
        ...defaultFilterValues,
        order: walletsFilters?.order || 'DESC',
        currencyIds: currentCurrencyIds.join(',') || undefined,
        typeWallet: typeWallet,
        showTokens: true,
        positiveBalance: hideZeroCheckbox,
        ...(effectiveWalletVersion ? { walletVersion: effectiveWalletVersion } : {}),
      });
    } else if (defaultFilterValues?.currencyIds?.length === 0) {
      setWalletsAdmin([]);
    }
  }, [walletsFilters?.order, effectiveWalletVersion, merchantData]);

  const handleReplenishButton = (address, currency, isModalOpen) => {
    setWalletAddress(address);
    setWalletCurrency(currency);
    setIsReplenishModalOpen(isModalOpen);
  };

  const openNotification = () => {
    notification.success({
      message: t('copied'),
      duration: 2,
    });
  };

  const openModal = walletId => {
    setWalletId(walletId);
    setIsKeyModalOpen(true);
  };

  const closeModal = () => {
    setIsKeyModalOpen(false);
    resetTwoFaState(false);
  };

  const handleOpenSettings = wallet => {
    setSelectedWallet(wallet);
    setOpenSettingsModal(true);
    checkAutosignStatus(merchantId, wallet?._id);
    checkPasswordStatus(merchantId, wallet?._id);
  };

  const handleOpenDelete = wallet => {
    setSelectedWallet(wallet);
    setOpenDeleteModal(true);
  };

  const handleOpenSignPassword = wallet => {
    setSelectedWallet(wallet);
    checkAutosignStatus(merchantId, wallet?._id);
    checkPasswordStatus(merchantId, wallet?._id);
    setIsOpenSignPassword(true);
  };

  const closeSign = () => {
    setIsOpenSignPassword(false);
    dispatch(downloadNewAutosignError(false));
    setModalTitle(false);
    const w = selectedWalletRef.current;
    if (merchantId && w?._id) {
      checkPasswordStatus(merchantId, w._id);
      setSecurityRefreshedWalletId(w._id);
    }
  };

  const closeSettingsOnly = () => {
    setOpenSettingsModal(false);
  };

  const openDownload = () => {
    setOpenSettingsModal(false);
    setIsOpenDownload(true);
  };

  const checkDownloadAutosign = useCallback(() => {
    const w = selectedWalletRef.current;
    if (merchantId && w?._id) {
      checkAutosignStatus(merchantId, w._id);
      checkPasswordStatus(merchantId, w._id);
    }
  }, [merchantId, checkAutosignStatus, checkPasswordStatus]);

  const loadMoreAdminWallets = selectedPage => {
    const { order, limit, search, currencyIds } = walletsFilters;
    const pageNumber = selectedPage.selected + 1;
    getAdminMerchantWallet({
      order: order,
      limit: limit,
      search: search.trim(),
      currencyIds: currencyIds.join(',') || undefined,
      typeWallet: typeWallet,
      page: pageNumber,
      typeNetwork: networkFilter,
      showTokens: true,
      positiveBalance: hideZeroCheckbox,
      ...(effectiveWalletVersion ? { walletVersion: effectiveWalletVersion } : {}),
    }).then(response => {
      if (response?.data) {
        setWalletAddress(response?.data?.entities);
      }
    });
  };

  const submitFilters = () => {
    const { order, limit, search, currencyIds } = walletsFilters;
    resetPageCounter();
    getAdminMerchantWallet({
      order: order,
      limit: limit,
      search: search.trim(),
      currencyIds: currencyIds.join(',') || undefined,
      typeWallet: typeWallet,
      page: 1,
      typeNetwork: networkFilter,
      showTokens: true,
      positiveBalance: hideZeroCheckbox,
      ...(effectiveWalletVersion ? { walletVersion: effectiveWalletVersion } : {}),
    }).then(response => {
      if (response?.data) {
        setWalletAddress(response?.data?.entities);
      }
    });
  };

  const updateList = () => {
    submitFilters();
  };

  const resetFilters = () => {
    const { currencyIds } = defaultFilterValues;
    getAdminMerchantWallet({
      ...defaultFilterValues,
      currencyIds: currencyIds.join(',') || undefined,
      typeWallet: typeWallet,
      page: 1,
      typeNetwork: networkFilter,
      showTokens: true,
      positiveBalance: hideZeroCheckbox,
      ...(effectiveWalletVersion ? { walletVersion: effectiveWalletVersion } : {}),
    }).then(response => {
      if (response?.data) {
        setWalletsAdmin(response?.data?.entities);
      }
    });
  };

  const walletsToUse = walletsAdmin?.map(wallet => {
    if (wallet.balances) {
      const nativeIndex = wallet.balances.findIndex(b => b.currency.currencyType === 'currency');
      const primaryIndex = nativeIndex >= 0 ? nativeIndex : 0;
      const primary = wallet.balances[primaryIndex];
      const tokens = wallet.balances
        .filter((_, i) => i !== primaryIndex)
        .map(b => ({
          currency: b.currency.name,
          currencyId: b.currency.id,
          currencyType: b.currency.currencyType,
          nodeType: b.currency.nodeType,
          holdBalance: b.holdBalance,
          balance: { value: b.balance.value, usd: b.balance.usd },
        }));
      return {
        _id: wallet._id,
        address: wallet.address,
        currency: primary.currency.name,
        currencyId: primary.currency.id,
        currencyType: primary.currency.currencyType,
        nodeType: primary.currency.nodeType,
        balance: { value: primary.balance.value, usd: primary.balance.usd },
        typeWallet: wallet.typeWallet,
        main: wallet.main,
        tokens,
        createdAt: wallet.createdAt,
        isSegwit: wallet.isSegwit,
      };
    }
    return wallet;
  });

  return (
    <React.Fragment>
      <ReplenishModal
        walletAddress={walletAddress}
        walletCurrency={walletCurrency}
        isReplenishModalOpen={isReplenishModalOpen}
        handleReplenishButton={handleReplenishButton}
      />
      <PrivateKeyModal
        merchantId={merchantId}
        walletId={walletId}
        setWalletId={setWalletId}
        isKeyModalOpen={isKeyModalOpen}
        closeModal={closeModal}
        openNotification={openNotification}
        getWalletPrivateKey={getWalletPrivateKey}
        showWalletBy={showWalletBy}
        getWalletMnemonicPhrase={getWalletMnemonicPhrase}
        getPassphrase={getPassphrase}
      />
      <WalletDeleteModal
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        merchantId={merchantId}
        walletId={selectedWallet?._id}
        walletAddress={selectedWallet?.address}
        deleteMerchantWallet={deleteMerchantWallet}
        typeWallet={typeWallet}
        walletsFilters={walletsFilters}
        networkFilter={networkFilter}
        isFromMerchantsWallets={isFromMerchantsWallets}
      />
      <SignPasswordModal
        merchantId={merchantId}
        autosignStatus={autosignStatus}
        passwordStatus={passwordStatus}
        isOpen={isOpenSignPassword}
        walletId={selectedWallet?._id}
        downloadAutosign={downloadAutosign}
        setPasswordSignature={setPasswordSignature}
        onCancel={closeSign}
        modalTitle={modalTitle}
        autosignStep={autosignStep}
        downloadAutosignStep={downloadAutosignStep}
        password={password}
      />
      <WalletSettingsModal
        openSettingsModal={openSettingsModal}
        setOpenSettingsModal={setOpenSettingsModal}
        selectedWallet={selectedWallet}
        wallet={selectedWallet}
        merchantId={merchantId}
        setSelectedWallet={setSelectedWallet}
        getWalletPrivateKey={getWalletPrivateKey}
        getWalletMnemonicPhrase={getWalletMnemonicPhrase}
        getPassphrase={getPassphrase}
        openNotification={openNotification}
        resetTwoFaState={resetTwoFaState}
        setWalletAsMain={setWalletAsMain}
        closeModal={closeSettingsOnly}
        statusAutosign={autosignStatus}
        statusPassword={passwordStatus}
        openSign={() => setIsOpenSignPassword(true)}
        typeWallet={typeWallet}
        downloadAutosign={downloadAutosign}
        checkStatusPassword={() => {
          const w = selectedWalletRef.current;
          if (merchantId && w?._id) {
            checkPasswordStatus(merchantId, w._id);
          }
        }}
        walletsFilters={walletsFilters}
        networkFilter={networkFilter}
        openDownload={openDownload}
        updateList={() => {
          checkDownloadAutosign();
          submitFilters();
          const w = selectedWalletRef.current;
          if (w?._id) {
            setSecurityRefreshedWalletId(w._id);
          }
        }}
        downloadError={downloadError}
      />
      <PasswordModal
        isOpen={isOpenDownload}
        closeModal={() => setIsOpenDownload(false)}
        downloadAutosignStep={downloadAutosignStep}
        merchantId={merchantId}
        walletId={selectedWallet?._id}
        downloadAutosign={downloadAutosign}
      />
      {currencies && currencies.length && (
        <>
          {canSwitchWalletVersion && (
            <div
              style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12, gap: 8, alignItems: 'center' }}
            >
              <span>Use Wallets 2.0 by default</span>
              <Switch
                checked={effectiveWalletVersion !== 'v1'}
                onChange={value => setAdminWalletVersion(value ? 'v2' : 'v1')}
              />
            </div>
          )}
          <WalletsFilters
            formName={formName}
            merchantName={name}
            currencies={currencies}
            initialValues={defaultFilterValues}
            submitFilters={submitFilters}
            resetFilters={resetFilters}
            fetching={loading}
            hideZeroCheckbox={hideZeroCheckbox}
            setCheckbox={setHideZeroCheckbox}
          />
        </>
      )}
      {!loading && walletsAdmin && walletsAdmin?.length > 0 ? (
        <>
          {isV2 ? (
            <div className="admin-wallet">
              <Row align="middle" className="admin-wallet__rowTitle">
                <Col span={1} />
                <Col span={10}>{t('address')}</Col>
                <Col span={4}>{t('amount')}</Col>
                <Col span={5} className="admin-wallet__cell-pad-right">{t('dataTime')}</Col>
                <Col span={4} />
              </Row>
              <div className="admin-wallet__content">
                {walletsAdmin.map(wallet => (
                  <AdminWalletItemV2
                    key={wallet._id}
                    wallet={wallet}
                  />
                ))}
              </div>
            </div>
          ) : (
            <div className={`wallets-page ${loading ? 'wallets-page_fetching' : ''}`}>
              {walletsToUse.map(wallet => (
                <WalletItem
                  autosignStep={autosignStep}
                  downloadAutosignStep={downloadAutosignStep}
                  key={wallet._id}
                  merchantId={merchantId}
                  wallet={wallet}
                  type="admin"
                  typeWallet={typeWallet}
                  downloadAutosign={downloadAutosign}
                  walletsFilters={walletsFilters}
                  openModal={openModal}
                  setPasswordSignature={setPasswordSignature}
                  autosignStatus={autosignStatus}
                  openNotification={openNotification}
                  deleteMerchantWallet={deleteMerchantWallet}
                  handleReplenishButton={handleReplenishButton}
                  setWalletAsMain={setWalletAsMain}
                  checkAutosignStatus={checkAutosignStatus}
                  checkPasswordStatus={checkPasswordStatus}
                  passwordStatus={passwordStatus}
                  currencies={currencies}
                  networkFilter={networkFilter}
                  getWalletPrivateKey={getWalletPrivateKey}
                  getPassphrase={getPassphrase}
                  getWalletMnemonicPhrase={getWalletMnemonicPhrase}
                  setShowWalletBy={setShowWalletBy}
                  isFromMerchantsWallets={isFromMerchantsWallets}
                  resetTwoFaState={resetTwoFaState}
                  updateList={updateList}
                  downloadError={downloadError}
                  walletVersion={effectiveWalletVersion}
                />
              ))}
            </div>
          )}
          {adminPages > 1 ? (
            <ReactPaginate
              pageCount={adminPages}
              pageRangeDisplayed={5}
              marginPagesDisplayed={2}
              onPageChange={loadMoreAdminWallets}
              containerClassName="pagination"
              activeClassName="active"
              previousLabel={'«'}
              nextLabel={'»'}
              breakLabel={'...'}
              forcePage={adminPage - 1}
            />
          ) : null}
        </>
      ) : !loading ? (
        <Empty description={t('nodata')} />
      ) : null}
      {loading && (
        <div className="wallets__loader">
          <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 24 }} spin />} />
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state, props) => ({
  merchantData: state.merchantData.data,
  currencies: state.currencies.data,
  autosignStatus: state.withdraw.autosignStatus,
  passwordStatus: state.withdraw.passwordStatus,
  walletsFilters: formValueSelector(props.formName)(state, 'search', 'order', 'limit', 'currencyIds'),
  autosignStep: state.withdraw.autosignStep,
  downloadAutosignStep: state.withdraw.downloadAutosignStep,
  downloadError: state.withdraw.downloadError,
  userMerchants: state.adminUsers.userMerchants.data,
});

const mapDispatchToProps = dispatch => ({
  getMerchantData: getMerchantData(dispatch),
  deleteMerchantWallet: deleteMerchantWallet(dispatch),
  setWalletAsMain: setWalletAsMain(dispatch),
  resetTwoFaState: resetTwoFaState(dispatch),
  getWalletPrivateKey: getWalletPrivateKey(dispatch),
  getPassphrase: getPassphrase(dispatch),
  resetPageCounter,
  getWalletMnemonicPhrase: getWalletMnemonicPhrase(dispatch),
  checkAutosignStatus: checkAutosignStatus(dispatch),
  setPasswordSignature: setPasswordSignature(dispatch),
  downloadAutosign: downloadAutosign(dispatch),
  checkPasswordStatus: checkPasswordStatus(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminMerchantWalletsList);
